//LIBRARIES
import {
  Controllers,
  ButtonSubmitController,
  FunctionGroupingArrayByKey,
} from "radium-omnibus";
import React from "react";

//RENDERS
import BusketRenderProgram from "./Basket.RenderProgram";
import BusketModalDateTime from "./Busket.ModalDateTime";
import SwitchCeles from "../../../components/attributes/SwitchCeles";
import Container from "../../../components/layouts/Container";
import TemplateModal from "../../../components/template/Template.Modal";

//CONTEXT
import { ContextLanguage } from "../../../context/Context.Language";
import { ContextCart } from "../../../context/Context.Cart";
import { AwaitComponent } from "../../../utils/useAutosuzeTextArea";

//CONSTANTS
import {
  LAST_TIME_YOU_STILL_CAN_BOOK,
  MAX_TEXT_LENGTH,
  RETURN_SAME_DAY,
  RETURN_SHOSE_TIME,
  RETURN_TIME,
  SYMBOL_CURRENCY,
  TEXT_ADD_PROGRAM,
  TEXT_BUSKET,
  TEXT_CONFIRM,
  TEXT_CONTACTLESS_PICKUP_RETURN,
  TEXT_EDIT,
  TEXT_ORDER_SUMMARY,
  TEXT_PICKUP,
  TEXT_PLACE_ORDER,
  TEXT_PLEASE_SELECT_DATE,
  TEXT_RETURN,
  TEXT_SAMEDAY_SERVICE,
  TIME_THAT_STILL_SAME_DAY_SERVICE,
} from "../../../utils/useConstants";
import {
  ICON_ADDRESS_DETAILS,
  ICON_DATE_TIME,
  ICON_INFO,
  ICON_LOCATION,
  ICON_SAMEDAY_SERVICE,
  ICON_SAMEDAY_SERVICE_DISABLE,
} from "../../../utils/useIcons";
import {
  STYLE_EDIT_BUSKET_ADDRESS,
  STYLE_FLEX_ITEMS_START,
  STYLE_HOVER_BLUE,
  STYLE_ICON_SAMEDAY,
  STYLE_LINK_BLUE_NO_MX,
  STYLE_MARGIN_READ,
  STYLE_MARGIN_TOP,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_MIN_H_FULL,
  STYLE_PADDING_WHITE_BASKET,
  STYLE_SUB_DETAIL,
  STYLE_SUB_TITLE,
  STYLE_TEXTAREA_BUSKET,
  STYLE_TITLE_BOLD,
  STYLE_TITLE_SEMIBOLD,
  STYLE_WRAPPER_MIDDLE_PROGRAM_BACK,
} from "../../../utils/useStyle";
import BusketRenderWater from "./Basket.RenderWater";
import PaymentMain from "../../payment/Payment.Main";
import { useDispatch, useSelector } from "react-redux";
import BasketCalculatePrice from "../function/Basket.CalculatePrice";
import {
  createPresent,
  createPresentStringDate,
  MAPPING_DATE,
  THIS_TIME_IN_N_OUT,
} from "../function/Busket.GenerateDate";
import BaskerFormatDataToBackEnd from "../function/Basket.FormatDataToBackEnd";
import BasketPayment from "../function/Basket.Payment";
import ProgramGoBack from "../../task/render/Program.GoBack";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  DrawerInfo,
  DrawerInfoMobile,
} from "../../../components/drawerInfo/DrawerInfo.Main";
import BasketLoadCalendar from "../function/Basket.LoadCalendar";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FunctionChangeFormatDateAgain,
  FunctionCloneSetValueToSesstion,
  FunctionCreateDay,
  FunctionCreateMonth,
  FunctionCreateYear,
  FunctionGetDataFromSessionStorage,
  FunctionGetPathUrl,
  isWithinRange,
  toISO,
} from "../../../utils/useFunction";
import { toast } from "react-toastify";
import BasketLoadAllPrevData from "../function/Basket.LoadAllPrevData";
import BasketAutoSelectDate, {
  BasketAutoSelectDateValue,
} from "../function/Basket.AutoSelectDate";
import useAutosizeTextArea from "../../../utils/useAutosuzeTextArea";
import {
  CreateThisReference,
  TriggerObserver,
} from "../../../utils/useObserver";
import {
  StoreDetailAddress,
  StoreSameDayService,
  StoreSelectedLocation,
  SystemStoreBasketAddress,
  SystemStoreStar,
} from "../../../utils/useStorage";
import { useWindowSize } from "../../../utils/useWindowSize";
import BasketOnClickEditAddress from "../function/Basket.OnClickEditAddress";
import { FunctionCreateHour } from "../../../utils/useFunction";
import AddressOnClickCurrentLocation from "../../address/functions/Address.OnClickCurrentLocation";
import BasketAutoSelectNewDate from "../function/Basket.AutoSelectNewDate";

const ComponentIntervalSameDay = ({
  address,
  calendars,
  config,
  language,
  sameDayService,
  setDateTime,
  setSameDayService,
  setOpenSameday,
  dateTime,
}) => {
  const [lock, setLock] = React.useState(false);
  const thisCalendarDate = calendars?.find(
    (item) =>
      item?.showDate ===
      `${FunctionCreateMonth()}.${FunctionCreateDay()}.${FunctionCreateYear()}`
  );

  const thisSameDayServiceStillLeft =
    thisCalendarDate?.season_mix_planned - thisCalendarDate?.season_mix_booked >
    0;

  const isDisabledSameDayService =
    address?.location === "PATTAYA" ||
    !thisSameDayServiceStillLeft ||
    !isWithinRange() ||
    config?.same_day_status === false ||
    lock;

  //check every miniute if 11.00 set same day service to false and set lock to true
  React.useEffect(() => {
    const newToday = FunctionCreateDay();
    const thisHour = FunctionCreateHour();
    const currentPickUpDate = Number(
      dateTime?.pick_up_date?.date?.split(".")[1]
    );
    const SelctedtTimStilleAvailable = thisHour < LAST_TIME_YOU_STILL_CAN_BOOK;
    const isToday = currentPickUpDate === newToday;
    const checkIn =
      address?.link &&
      calendars?.length > 0 &&
      !SelctedtTimStilleAvailable &&
      isToday;

    const isReturnAndPickUpSameDay =
      dateTime?.return_date?.date === dateTime?.pick_up_date?.date;

    // console.log("currentPickUpDate", {
    //   currentPickUpDate,
    //   dateTime,
    //   SelctedtTimStilleAvailable,
    //   isReturnAndPickUpSameDay,
    // });

    const interval = setInterval(() => {
      if (
        FunctionCreateHour() >= TIME_THAT_STILL_SAME_DAY_SERVICE &&
        isToday &&
        isReturnAndPickUpSameDay
      ) {
        sessionStorage.removeItem("date_time");
        // setDateTime(null);
        BasketAutoSelectNewDate({
          dateTime,
          calendars,
          setDateTime,
          address,
        });
        setSameDayService(false);
        setLock(true);
      }

      if (FunctionCreateHour() >= LAST_TIME_YOU_STILL_CAN_BOOK && checkIn) {
        sessionStorage.removeItem("date_time");
        // setDateTime(null);
        BasketAutoSelectNewDate({
          dateTime,
          calendars,
          setDateTime,
          address,
        });
        setSameDayService(false);
      }
    }, 10000);

    if (
      FunctionCreateHour() >= TIME_THAT_STILL_SAME_DAY_SERVICE &&
      isToday &&
      isReturnAndPickUpSameDay
    ) {
      sessionStorage.removeItem("date_time");
      // setDateTime(null);
      BasketAutoSelectNewDate({
        dateTime,
        calendars,
        setDateTime,
        address,
      });
      setSameDayService(false);
      setLock(true);
    }
    if (FunctionCreateHour() >= LAST_TIME_YOU_STILL_CAN_BOOK && checkIn) {
      sessionStorage.removeItem("date_time");
      // setDateTime(null);
      BasketAutoSelectNewDate({
        dateTime,
        calendars,
        setDateTime,
        address,
      });
      setSameDayService(false);
    }
    return () => clearInterval(interval);
  }, [dateTime, calendars, address]);

  return (
    <React.Fragment>
      <div
        className={`flex justify-between items-center bg-white px-4  pt-2 pb-3 md:pb-1 . md:px-[25px] md:mx-10 xl:mx-padding_read`}
      >
        <div
          className={`flex items-center ${
            isDisabledSameDayService ? " gap-2 " : " gap-[6px] "
          }`}
        >
          {isDisabledSameDayService ? (
            <ICON_SAMEDAY_SERVICE_DISABLE className={STYLE_ICON_SAMEDAY} />
          ) : (
            <ICON_SAMEDAY_SERVICE className={STYLE_ICON_SAMEDAY} />
          )}
          <div
            className={`${
              isDisabledSameDayService
                ? `${
                    language === "TH"
                      ? " font-semibold  text-sm-th md:text-base-th leading-6 "
                      : " font-semibold  text-sm md:text-base leading-6 "
                  }  text-laundry-gray-30 -ml-0.5 <50> `
                : STYLE_SUB_TITLE(language)
            }`}
          >
            {TEXT_SAMEDAY_SERVICE[language]}
          </div>
          <ICON_INFO
            onClick={() => {
              setOpenSameday(true);
            }}
            className={`w-5 cursor-pointer  -ml-1 ${STYLE_HOVER_BLUE}`}
          />
        </div>
        {isDisabledSameDayService ? (
          <React.Fragment>
            <div className={``}>
              <SwitchCeles
                value={sameDayService}
                onClick={() => {
                  if (sameDayService) {
                    const findNearestTime = BasketAutoSelectDateValue({
                      calendars,
                      address,
                    });
                    FunctionCloneSetValueToSesstion(
                      "date_time",
                      setDateTime,

                      {
                        isDateTimeOpen: false,
                        pick_up_date: findNearestTime?.pick_up_date,
                        pick_up_time: findNearestTime?.pick_up_time,
                        return_date: findNearestTime?.return_date,
                        return_time: findNearestTime?.return_time,
                      }
                    );
                    FunctionCloneSetValueToSesstion(
                      "sameDayService",
                      setSameDayService,
                      false
                    );
                  } else {
                    return null;
                  }
                }}
              />
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className={`STYLE_MARGIN_READ_RIGHT`}>
              <SwitchCeles
                value={sameDayService}
                onClick={() => {
                  if (sameDayService) {
                    const findNearestTime = BasketAutoSelectDateValue({
                      calendars,
                      address,
                    });
                    // console.log(
                    //   "findNearestTime",
                    //   findNearestTime
                    // );
                    FunctionCloneSetValueToSesstion(
                      "date_time",
                      setDateTime,

                      {
                        isDateTimeOpen: false,
                        pick_up_date: findNearestTime?.pick_up_date,
                        pick_up_time: findNearestTime?.pick_up_time,
                        return_date: findNearestTime?.return_date,
                        return_time: findNearestTime?.return_time,
                      }
                    );
                    FunctionCloneSetValueToSesstion(
                      "sameDayService",
                      setSameDayService,
                      false
                    );
                  } else {
                    FunctionCloneSetValueToSesstion("date_time", setDateTime, {
                      isDateTimeOpen: false,
                      pick_up_date: {
                        date: createPresent,
                        disabled: false,
                        filter: false,
                        name: createPresentStringDate,
                      },
                      pick_up_time: THIS_TIME_IN_N_OUT,
                      return_date: {
                        date: createPresent,
                        disabled: false,
                        filter: false,
                        name: createPresentStringDate,
                      },
                      return_time: THIS_TIME_IN_N_OUT,
                    });
                    FunctionCloneSetValueToSesstion(
                      "sameDayService",
                      setSameDayService,
                      true
                    );
                  }
                }}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export const FunctuionFormatDate = (dateTime) => {
  const DAY_IN_ENGLISH = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  };

  const DAY_IN_THAI = {
    0: "อาทิตย์",
    1: "จันทร์",
    2: "อังคาร",
    3: "พุธ",
    4: "พฤหัสบดี",
    5: "ศุกร์",
    6: "เสาร์",
  };

  const pickUpDate = new Date(toISO(dateTime?.pick_up_date?.date));
  const returnDate = new Date(toISO(dateTime?.return_date?.date));

  const pickUpDateInEnglish = `${DAY_IN_ENGLISH[pickUpDate.getDay()]}`;
  const pickUpDateInThai = `${DAY_IN_THAI[pickUpDate.getDay()]}`;
  const returnDateInEnglish = `${DAY_IN_ENGLISH[returnDate.getDay()]}`;
  const returnDateInThai = `${DAY_IN_THAI[returnDate.getDay()]}`;

  return {
    ...dateTime,
    pickUpDateInEnglish,
    pickUpDateInThai,
    returnDateInEnglish,
    returnDateInThai,
  };
};

const BusketDetails = React.memo(({ config }) => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { cart, master, setCart } = React.useContext(ContextCart);
  const { user } = useSelector((state) => state.auth);

  const [calendars, setCalendars] = React.useState([]);

  const [form, setForm] = React.useState(null);
  // const [sameDayService, setSameDayService] = React.useState(false);
  const [dateTime, setDateTime] = React.useState("");
  const [refNumber, setRefNumber] = React.useState("");
  // const [addressDetail, setAddressDetail] = React.useState("");
  const [show, setShow] = React.useState(false);
  const [width, setWidth] = React.useState(0);
  // const [specialRequest, setSpecialRequest] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [openSameday, setOpenSameday] = React.useState(false);
  const [openSummary, setOpenSummary] = React.useState(false);
  // const [openSpecialRequest, setOpenSpecialRequest] = React.useState(false);
  const [tellUsMore, setTellUsMore] = React.useState(false);
  const [last, setLast] = React.useState(false);

  const [clicked, setClicked] = React.useState(false);

  const [loadDetailFinished, setLoadDetailFinished] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setWidth(refButton.current?.clientWidth);
    }, 300);
  }, []);

  const isMobile = useIsMobile();
  const size = useWindowSize();

  const refButton = React.useRef(null);

  const address = SystemStoreBasketAddress((state) => state.address);
  const setAddress = SystemStoreBasketAddress((state) => state.setAddress);

  const sameDayService = StoreSameDayService((state) => state.sameDayService);

  const [tempDetailAddress, setTempDetailAddress] = React.useState("");
  const setSameDayService = StoreSameDayService(
    (state) => state.setSameDayService
  );
  const setStar = SystemStoreStar((state) => state.setStar);
  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );
  const selectedLocation = StoreSelectedLocation(
    (state) => state.selectedLocation
  );

  const detailAddress = StoreDetailAddress((state) => state.detailAddress);
  const setDetailAddress = StoreDetailAddress(
    (state) => state.setDetailAddress
  );

  const hasMyShoes = cart?.some((i) => {
    return (
      i?.type === "PACKAGE" &&
      i?.master === true &&
      i?.master_type === "My Shoes"
    );
  });

  const FunctionResetState = () => {
    setDetailAddress("");
    setAddress("");
    setDateTime("");
    setSameDayService(false);
    setForm({});
    setCart([]);
    setRefNumber("");
    sessionStorage.removeItem("busket_program");
    sessionStorage.removeItem("cart");
    sessionStorage.removeItem("redirect");
    sessionStorage.removeItem("date_time");
    sessionStorage.removeItem("address");
    // sessionStorage.removeItem("addressDetail");
    setClicked(false);
  };

  React.useEffect(() => {
    if (
      !tempDetailAddress &&
      (detailAddress || detailAddress === "") &&
      !loadDetailFinished
    ) {
      setTempDetailAddress(detailAddress);
      setLoadDetailFinished(true);
    }
  }, [setTempDetailAddress, detailAddress]);

  // console.log("detailAddress", { detailAddress, tempDetailAddress });

  React.useEffect(() => {
    BasketLoadAllPrevData({
      setRefNumber,
      setDateTime,
      setAddress,
      // setAddressDetail,
      setDetailAddress,
      user,
      address,
      setClicked,
      setTellUsMore,
    });
  }, [user]);

  React.useEffect(() => {
    if (address?.location || dateTime?.isDateTimeOpen) {
      BasketLoadCalendar(
        setCalendars,
        address?.location,
        setDateTime,
        dateTime
      );
    }
    return () => {};
  }, [address?.location, dateTime?.isDateTimeOpen]);

  React.useEffect(() => {
    BasketAutoSelectDate({ dateTime, calendars, setDateTime, address });
  }, [calendars, address]);

  React.useEffect(() => {
    window.addEventListener("pageshow", () => {
      setClicked(false);
    });
    return () => {
      window.removeEventListener("beforeunload", () => {
        setClicked(false);
      });
    };
  }, []);

  React.useEffect(() => {
    BasketAutoSelectDate({ dateTime, calendars, setDateTime, address });
  }, [dateTime]);

  React.useEffect(() => {
    const findLastElement = document.getElementById("last-element");
    if (findLastElement) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio === 0) {
          setLast(false);
        } else {
          setLast(true);
        }
      });
      observer.observe(findLastElement);
      return () => observer.unobserve(findLastElement);
    }
  }, []);

  const textAreaRef1 = React.useRef();
  // const textAreaRef2 = React.useRef();

  useAutosizeTextArea(
    textAreaRef1.current,
    detailAddress,
    isMobile ? (language === "TH" ? 135 : 175) : language === "TH" ? 88 : 112,
    true,
    language
  );

  // useAutosizeTextArea(
  //   textAreaRef2.current,
  //   specialRequest,
  //   65,
  //   true,
  //   openSpecialRequest
  // );

  // const setIsShowAnother = StoreIsShowAnotherValue(
  //   (state) => state.setIsShowAnother
  // );

  // const size = useWindowSize();

  // GoogleTagManager.initialize({
  //   gtmId: "GTM-N7RXMXX",
  //   dataLayerName: "purchase",
  //   dataLayer: {
  //     event: "purchase",
  //     transactionId: refNumber,
  //     transactionValue: BasketCalculatePrice(
  //       form,
  //       cart,
  //       sameDayService,
  //       config?.same_day_price
  //     ),
  //   },
  // });

  // console.log("dateTime", dateTime);

  return (
    <div className={STYLE_MIN_H_FULL}>
      <Container
        style={`text-gray-700 bg-white md:bg-laundry-borderbottomline relative  h-full ${STYLE_MARGIN_TOP} `}
      >
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <div className={`${STYLE_MAX_WIDTH_DESKTOP} `}>
          <div className={`relative md:pt-11 pb-0 md:pb-[30px] md:ordershadow`}>
            <Controllers
              onSubmit={(e) => {
                setForm((prev) => ({ ...prev, ...e }));
              }}
              classNameSubmit="hidden"
              classNameWrapper="hidden"
              fields={[
                {
                  type: "customs",
                  name: "busket_user",
                  fieldCustoms: ({ value, setValue }) => {
                    return (
                      <div>
                        <div
                          className={`${STYLE_WRAPPER_MIDDLE_PROGRAM_BACK} ${STYLE_MARGIN_READ}`}
                        >
                          <ProgramGoBack
                            title={TEXT_BUSKET[language]}
                            // onClick={() => {
                            //   const redirect =
                            //     sessionStorage.getItem("redirect-back-to");
                            //   navigate(redirect || "/");
                            // }}
                          />
                        </div>
                        <div
                          className={`${STYLE_MARGIN_READ} px-4 pb-2 md:px-6 md:pt-2 bg-white flex gap-1 items-center`}
                        >
                          <div className={STYLE_TITLE_SEMIBOLD(language)}>
                            {TEXT_CONTACTLESS_PICKUP_RETURN[language]}
                          </div>
                          <ICON_INFO
                            onClick={() => {
                              setOpen(true);
                            }}
                            className={`w-5 cursor-pointer   ${STYLE_HOVER_BLUE}`}
                          />
                        </div>

                        <div
                          id={"first-div-of-address"}
                          className={` flex justify-between  ${STYLE_MARGIN_READ} ${STYLE_PADDING_WHITE_BASKET} `}
                        >
                          <div className={`flex gap-2 items-start w-full `}>
                            <ICON_LOCATION
                              className={`w-6 h-6  text-[#3AB4ED] flex-none ${
                                language === "TH" ? "" : "-mt-[2px]"
                              }`}
                            />
                            <div className={STYLE_SUB_TITLE(language)}>
                              {/* {TEXT_ADDRESS[language]} */}
                              <div className="underline">
                                {language === "TH"
                                  ? "ที่อยู่ของคุณ"
                                  : "Your Address"}
                              </div>
                              <div
                                className={`${STYLE_SUB_DETAIL(
                                  language
                                )} mt-2 <31>`}
                              >
                                {address?.title ?? ""}
                                <div>{address?.name ?? ""}</div>
                                {address ? (
                                  ` ${address?.formatted_address}`
                                ) : (
                                  <span>
                                    {language === "TH" ? (
                                      <span>
                                        คลิก{" "}
                                        <span
                                          onClick={async () => {
                                            await AddressOnClickCurrentLocation(
                                              false,
                                              setSelectedLocation,
                                              setAddress
                                            );
                                            navigate("/Address");
                                          }}
                                          className={STYLE_LINK_BLUE_NO_MX}
                                        >
                                          ที่นี่
                                        </span>{" "}
                                        เพื่อค้นหาที่อยู่ของคุณ
                                      </span>
                                    ) : (
                                      <span>
                                        Click{" "}
                                        <span
                                          onClick={async () => {
                                            await AddressOnClickCurrentLocation(
                                              false,
                                              setSelectedLocation,
                                              setAddress
                                            );
                                            navigate("/Address");
                                          }}
                                          className={STYLE_LINK_BLUE_NO_MX}
                                        >
                                          here
                                        </span>{" "}
                                        to search your address
                                      </span>
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div
                            onClick={() => {
                              BasketOnClickEditAddress({
                                user,
                                address,
                                setStar,
                                navigate,
                                setSelectedLocation,
                                selectedLocation,
                                detailAddress: detailAddress,
                                tempDetailAddress: tempDetailAddress,
                                dispatch,
                              });
                            }}
                            className={`${STYLE_EDIT_BUSKET_ADDRESS(
                              language
                            )} mr-0 mt-0.5`}
                          >
                            {TEXT_EDIT[language]}
                          </div>
                        </div>
                        <div className={isMobile ? "" : ""}>
                          <div
                          // className={`${STYLE_MARGIN_READ} hidden md:block bg-white md:px-6 md:p-3`}
                          >
                            {/* <div
                              className={`${STYLE_BORDER_BUSKET} hidden md:block my-0 `}
                            ></div> */}
                          </div>
                          <div
                            id="first-div-of-date-n-time"
                            // className={`flex justify-between  bg-white px-4 pb-2 md:pb-6 md:px-6 ${STYLE_MARGIN_READ} md:rounded-b-xl`}
                            className={`flex justify-between  bg-white px-4  md:px-6 ${STYLE_MARGIN_READ} `}
                          >
                            <div className={STYLE_FLEX_ITEMS_START}>
                              <ICON_DATE_TIME
                                className={`w-6 h-6 ${
                                  language === "TH"
                                    ? ""
                                    : isMobile
                                    ? "-mt-[3px]"
                                    : ""
                                }`}
                              />
                              <div className={STYLE_SUB_TITLE(language)}>
                                <div className="underline">
                                  {/* {TEXT_DATE_AND_TIME[language]} */}
                                  {language === "TH"
                                    ? "เวลารับส่ง"
                                    : "Your Time"}
                                </div>
                                <div
                                  className={`${STYLE_SUB_DETAIL(
                                    language
                                  )} space-y-2 mt-2 <33>`}
                                >
                                  <div className={STYLE_SUB_DETAIL(language)}>
                                    <span className="font-semibold">
                                      {TEXT_PICKUP[language]}
                                    </span>
                                    :
                                    {dateTime?.pick_up_date?.name &&
                                    dateTime?.pick_up_date?.date &&
                                    dateTime?.pick_up_time ? (
                                      <span className=" ml-[6px]">
                                        {language === "TH" ? (
                                          <React.Fragment>
                                            {
                                              MAPPING_DATE[
                                                dateTime?.pick_up_date?.name
                                              ]
                                            }
                                            {/* ที่ */}
                                          </React.Fragment>
                                        ) : (
                                          <React.Fragment>
                                            {dateTime?.pick_up_date?.name},
                                          </React.Fragment>
                                        )}{" "}
                                        {FunctionChangeFormatDateAgain(
                                          dateTime?.pick_up_date?.date
                                        )}
                                      </span>
                                    ) : (
                                      ` ${
                                        !address?.location
                                          ? language === "TH"
                                            ? "กรุณาเลือกที่อยู่ของคุณก่อน"
                                            : "Please select Your Address first"
                                          : TEXT_PLEASE_SELECT_DATE[language]
                                      }`
                                    )}
                                  </div>
                                  <div
                                    className={`${STYLE_SUB_DETAIL(language)}`}
                                  >
                                    <span className="font-semibold">
                                      {TEXT_RETURN[language]}
                                      {language === "TH" ? " ภายใน " : " by "}
                                      {sameDayService
                                        ? `${RETURN_SAME_DAY}:00${
                                            language === "TH" ? " น." : ""
                                          }`
                                        : hasMyShoes
                                        ? `${RETURN_SHOSE_TIME}:00${
                                            language === "TH" ? " น." : ""
                                          }`
                                        : `${RETURN_TIME}:00${
                                            language === "TH" ? " น." : ""
                                          }`}
                                    </span>
                                    :
                                    {language === "TH" && size.width < 375 ? (
                                      //iphone 11pro
                                      <React.Fragment>
                                        {dateTime?.return_date?.name &&
                                        dateTime?.return_date?.date &&
                                        dateTime?.return_time ? (
                                          <div className="mt-2">
                                            {language === "TH" ? (
                                              <React.Fragment>
                                                {
                                                  MAPPING_DATE[
                                                    dateTime?.return_date?.name
                                                  ]
                                                }
                                                {/* ที่ */}
                                              </React.Fragment>
                                            ) : (
                                              <React.Fragment>
                                                {dateTime?.return_date?.name},
                                              </React.Fragment>
                                            )}{" "}
                                            {FunctionChangeFormatDateAgain(
                                              dateTime?.return_date?.date
                                            )}
                                          </div>
                                        ) : (
                                          ` ${
                                            !address?.location
                                              ? language === "TH"
                                                ? "กรุณาเลือกที่อยู่ของคุณก่อน"
                                                : "Please select Your Address first"
                                              : TEXT_PLEASE_SELECT_DATE[
                                                  language
                                                ]
                                          }`
                                        )}
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment>
                                        {dateTime?.return_date?.name &&
                                        dateTime?.return_date?.date &&
                                        dateTime?.return_time ? (
                                          <span
                                            className={
                                              isMobile ? "ml-1" : "ml-[6px]"
                                            }
                                          >
                                            {language === "TH" ? (
                                              <React.Fragment>
                                                {
                                                  MAPPING_DATE[
                                                    dateTime?.return_date?.name
                                                  ]
                                                }
                                                {/* ที่ */}
                                              </React.Fragment>
                                            ) : (
                                              <React.Fragment>
                                                {dateTime?.return_date?.name},
                                              </React.Fragment>
                                            )}{" "}
                                            {FunctionChangeFormatDateAgain(
                                              dateTime?.return_date?.date
                                            )}
                                          </span>
                                        ) : (
                                          ` ${
                                            !address?.location
                                              ? language === "TH"
                                                ? "กรุณาเลือกที่อยู่ของคุณก่อน"
                                                : "Please select Your Address first"
                                              : TEXT_PLEASE_SELECT_DATE[
                                                  language
                                                ]
                                          }`
                                        )}
                                      </React.Fragment>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {sameDayService ? (
                              <React.Fragment />
                            ) : (
                              <div
                                onClick={() => {
                                  if (address?.location) {
                                    FunctionCloneSetValueToSesstion(
                                      "date_time",
                                      setDateTime,
                                      {
                                        ...dateTime,
                                        isDateTimeOpen: true,
                                      }
                                    );
                                  } else {
                                    return;
                                  }
                                }}
                                className={`${
                                  address?.location
                                    ? STYLE_EDIT_BUSKET_ADDRESS(language)
                                    : STYLE_EDIT_BUSKET_ADDRESS(language)
                                } mr-0 mt-0.5`}
                              >
                                {
                                  address?.location
                                    ? TEXT_EDIT[language]
                                    : TEXT_EDIT[language]
                                  // <Tooltip
                                  //   mode="left"
                                  //   message={
                                  //     TEXT_PLEASE_SELECT_LOCATION[language]
                                  //   }
                                  // >
                                  //   {TEXT_EDIT[language]}
                                  // </Tooltip>
                                }
                              </div>
                            )}
                          </div>
                          {dateTime?.isDateTimeOpen &&
                            !sameDayService &&
                            (isMobile ? (
                              <DrawerInfoMobile
                                showCloseButton={false}
                                showSaveButton={true}
                                isButtonFullWidth={true}
                                open={dateTime?.isDateTimeOpen}
                                setOpen={() => {
                                  FunctionCloneSetValueToSesstion(
                                    "date_time",
                                    setDateTime,
                                    {
                                      ...dateTime,
                                      isDateTimeOpen: false,
                                    }
                                  );
                                }}
                                info={
                                  <BusketModalDateTime
                                    value={dateTime}
                                    setValue={setDateTime}
                                    calendars={calendars}
                                    isMobile={isMobile}
                                  />
                                }
                              />
                            ) : (
                              <TemplateModal
                                acceptText={TEXT_CONFIRM[language]}
                                showCloseButton={false}
                                showSaveButton={true}
                                isButtonFullWidth={true}
                                open={dateTime?.isDateTimeOpen}
                                classNameSave={`${
                                  language === "EN"
                                    ? "font-Poppins"
                                    : "font-NotoSansThai"
                                } `}
                                setOpen={() => {
                                  FunctionCloneSetValueToSesstion(
                                    "date_time",
                                    setDateTime,
                                    {
                                      ...dateTime,
                                      isDateTimeOpen: false,
                                    }
                                  );
                                }}
                                panel={
                                  <BusketModalDateTime
                                    value={dateTime}
                                    setValue={setDateTime}
                                    calendars={calendars}
                                    isMobile={isMobile}
                                  />
                                }
                              />
                            ))}
                        </div>
                        <ComponentIntervalSameDay
                          address={address}
                          calendars={calendars}
                          config={config}
                          language={language}
                          sameDayService={sameDayService}
                          setDateTime={setDateTime}
                          setSameDayService={setSameDayService}
                          setOpenSameday={setOpenSameday}
                          dateTime={dateTime}
                        />
                        <React.Fragment>
                          {/* <div
                            className={` flex justify-between items-center gap-2 ${
                              tellUsMore ? "" : " rounded-b-xl "
                            }  bg-white  px-4 md:px-6 py-4 ${STYLE_MARGIN_READ}`}
                          >
                            <div className={` flex items-center space-x-2 `}>
                              <ICON_ADDRESS_DETAILS className=" w-6 h-6 " />
                              <div className={STYLE_SUB_TITLE(language)}>
                                {language === "TH"
                                  ? "บอกเราเพิ่มเติม"
                                  : "Tell Us More"}
                              </div>
                            </div>
                            <SwitchCeles
                              value={tellUsMore}
                              onClick={() => {
                                setTellUsMore(!tellUsMore);
                                FunctionCloneSetValueToSesstion(
                                  "tellUsMore",
                                  setValue,
                                  !tellUsMore
                                );
                              }}
                            />
                          </div> */}

                          {tellUsMore && textAreaRef1 && (
                            <AwaitComponent>
                              <div
                                className={`${STYLE_MARGIN_READ} bg-white px-4 md:px-6 pb-2 md:pb-6 md:rounded-b-xl pt-2`}
                              >
                                <textarea
                                  maxLength={MAX_TEXT_LENGTH}
                                  style={{
                                    overflow: "hidden",
                                    resize: "none",
                                    height: "auto",
                                    fontFamily: /^[\u0E00-\u0E7F]*$/.test(
                                      String(detailAddress)?.replace(/ /g, "")
                                    )
                                      ? "Noto Sans Thai"
                                      : "Poppins",
                                    fontSize:
                                      /^[\u0E00-\u0E7F]*$/.test(
                                        String(detailAddress)?.replace(/ /g, "")
                                      ) && isMobile
                                        ? "15px"
                                        : /^[\u0E00-\u0E7F]*$/.test(
                                            String(detailAddress)?.replace(
                                              / /g,
                                              ""
                                            )
                                          ) && !isMobile
                                        ? "18px"
                                        : !/^[\u0E00-\u0E7F]*$/.test(
                                            String(detailAddress)?.replace(
                                              / /g,
                                              ""
                                            )
                                          ) && isMobile
                                        ? "13px"
                                        : "16px",
                                  }}
                                  ref={textAreaRef1}
                                  value={detailAddress}
                                  // className={`
                                  // ${STYLE_TEXTAREA_BUSKET(language)}`}
                                  className={` ${
                                    language === "TH"
                                      ? " placeholder:text-13-th md:placeholder:text-base-th  "
                                      : " placeholder:text-13 md:placeholder:text-base "
                                  }  w-full  border border-laundry-red-100 rounded-md text-laundry-gray-100 font-normal h-12 ${
                                    isMobile ? " p-[10px] " : " p-[14px] "
                                  } md:py-2 px-3   focus:outline-none  leading-5 md:leading-6  `}
                                  placeholder={
                                    // TEXT_PLACEHOLDER_ADDRESS_DETAIL[language]
                                    language === "TH"
                                      ? `กรุณาระบุเลขที่ห้องและจุดรับส่งให้ชัดเจนในช่องนี้ เช่น ล็อบบี้หรือแผนกต้อนรับของโรงแรม จุดรับส่งของคอนโด รปภ. หรืออื่นๆ บริการไร้การสัมผัสของเราช่วยคุณประหยัดเวลา – คุณไม่ต้องรอการรับส่งคืนออเดอร์เลย! หากมีความต้องการอื่นๆ กรุณาแจ้งเราที่นี่ด้วย!`
                                      : `Please write your ROOM NUMBER here and tell us exactly WHERE you will leave your order for us to pick up and return, e.g. lobby, reception, drop-off table, security guard, etc. Our service is fully CONTACTLESS to save your valuable time - you never need to wait for us, neither for pick up nor for return! Any other instructions? Write them here too!`
                                  }
                                  onChange={(e) => {
                                    setDetailAddress(e.target.value);
                                    // FunctionCloneSetValueToSesstion(
                                    //   "addressDetail",
                                    //   setAddressDetail,
                                    //   e.target.value
                                    // );
                                  }}
                                />
                              </div>
                            </AwaitComponent>
                          )}
                        </React.Fragment>
                      </div>
                    );
                  },
                },
              ]}
            />

            <Controllers
              loadData={{
                busket_program:
                  FunctionGetDataFromSessionStorage("busket_program"),
              }}
              fields={[
                {
                  type: "customs",
                  name: "busket_program",
                  fieldCustoms: ({ value, setValue }) => {
                    return (
                      <div className="">
                        <div
                          id="first-div-of-programs"
                          className={`flex justify-between items-center  ${STYLE_MARGIN_READ} ${STYLE_PADDING_WHITE_BASKET}  md:rounded-t-xl pt-4 border-t-4 border-[#F5F6F9] mt-4 md:border-none `}
                        >
                          <div className=" flex items-center ">
                            <div className={STYLE_TITLE_SEMIBOLD(language)}>
                              {TEXT_ORDER_SUMMARY[language]}
                            </div>
                            <ICON_INFO
                              onClick={() => {
                                setOpenSummary(true);
                              }}
                              className={`w-5 cursor-pointer mx-1  ${STYLE_HOVER_BLUE}`}
                            />
                          </div>

                          <div
                            onClick={() => {
                              navigate("/OurServices");
                            }}
                            className={`${
                              language === "TH"
                                ? " text-xs-th md:text-base-th "
                                : " text-xs md:text-base "
                            } text-laundry-primary-blue  text-end  font-semibold cursor-pointer  hover:text-laundry-gray-80 mt-0.5`}
                          >
                            {TEXT_ADD_PROGRAM[language]}
                          </div>
                        </div>
                        <div className={isMobile ? "" : " "}>
                          {sameDayService && (
                            <div
                              className={` ${STYLE_MARGIN_READ} bg-white  px-4 md:px-6 `}
                            >
                              <div
                                className={`flex border-b border-[#D0D3E5] space-x-4 py-4 items-center`}
                              >
                                <img
                                  src="/icons/go_same_day.png"
                                  className="ml-.05 rounded-full bg-laundry-primary-blue-10 shadow-lg  w-14 h-14  xl:w-border_blue xl:h-border_blue 2xl:w-16 2xl:h-16  3xl:w-20 3xl:h-20"
                                />
                                <div className={`w-[95%]`}>
                                  <div
                                    className={`${STYLE_TITLE_BOLD(
                                      language
                                    )} flex justify-between items-center `}
                                  >
                                    Same Day Express Service
                                    <div
                                      className={STYLE_TITLE_SEMIBOLD(language)}
                                    >
                                      <span className="font-NotoSansThai">
                                        {SYMBOL_CURRENCY}
                                      </span>
                                      {config?.same_day_price}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {cart
                            ?.filter((item) => {
                              return item.type === "PACKAGE";
                            })
                            ?.map((item, index) => {
                              return (
                                <div
                                  className={`${STYLE_MARGIN_READ} bg-white  px-4 md:px-6   `}
                                >
                                  <BusketRenderProgram
                                    value={value}
                                    setValue={setValue}
                                    data={item}
                                    key={`key-of-basket-${index}`}
                                    raw={cart}
                                    index={index}
                                  />
                                </div>
                              );
                            })}

                          {cart
                            ?.filter((item) => {
                              return item.type === "WATER";
                            })
                            ?.map((water, index) => {
                              return (
                                <div
                                  className={`${STYLE_MARGIN_READ} bg-white pt-1  px-4 md:px-6`}
                                >
                                  <BusketRenderWater
                                    data={water}
                                    key={`key-of-water-${index}`}
                                  />
                                </div>
                              );
                            })}

                          {isMobile ? (
                            <div className="pb-4" />
                          ) : (
                            <div
                              className={`first-letter:
                         flex justify-between items-center gap-2 ${
                           value?.special_request ? "" : " rounded-b-xl "
                         }  bg-white  px-4 md:px-6 py-4 ${STYLE_MARGIN_READ} <21>`}
                            />
                          )}
                          {/* <div
                            className={` flex justify-between items-center gap-2 ${
                              value?.special_request ? "" : " rounded-b-xl "
                            }  bg-white  px-4 md:px-6 py-4 ${STYLE_MARGIN_READ}`}
                          >
                            <div
                              className={`${
                                value?.special_request
                                  ? " text-laundry-gray-100 "
                                  : " text-laundry-gray-30 "
                              } ${
                                language === "TH"
                                  ? " text-sm-th md:text-base-th "
                                  : " text-sm md:text-base "
                              } font-semibold`}
                            >
                              {TEXT_SPECIAL_REQUEST[language]}
                            </div>
                            <SwitchCeles
                              value={value?.special_request || false}
                              onClick={() => {
                                setOpenSpecialRequest(!value?.special_request);
                                FunctionCloneSetValueToSesstion(
                                  "busket_program",
                                  setValue,
                                  {
                                    ...value,
                                    special_request: !value.special_request,
                                  }
                                );
                              }}
                            />
                          </div> */}

                          {/* <div
                            style={{
                              display: value?.special_request
                                ? "block"
                                : "none",
                            }}
                            className={`${STYLE_MARGIN_READ} bg-white px-4 md:px-6 rounded-b-xl `}
                          >
                            <div className="">
                              <textarea
                                maxLength={MAX_TEXT_LENGTH}
                                style={{
                                  overflow: "hidden",
                                  resize: "none",
                                  // height: "auto",
                                }}
                                ref={textAreaRef2}
                                value={value?.special_request_information}
                                className={STYLE_TEXTAREA_SPECIAL_REQUEST_2(
                                  language
                                )}
                                placeholder={TEXT_TELL_US[language]}
                                onChange={(e) => {
                                  setSpecialRequest(e.target.value);
                                  FunctionCloneSetValueToSesstion(
                                    "busket_program",
                                    setValue,
                                    {
                                      ...value,
                                      special_request_information:
                                        e.target.value,
                                    }
                                  );
                                }}
                              />
                            </div>
                          </div> */}
                        </div>
                      </div>
                    );
                  },
                },
              ]}
              onSubmit={(e) => {
                setForm((prev) => ({
                  ...prev,
                  ...e,
                  cart: cart,
                  programs: BaskerFormatDataToBackEnd(cart),
                }));
              }}
              classNameSubmit="hidden"
            />
          </div>
        </div>
      </Container>

      <div className="bg-white ">
        <div
          className={`w-full px-4   xl:px-padding_read pt-4 pb-10 md:pt-8 md:pb-8 bg-white  max-w-desktop mx-auto`}
        >
          {/* <ComponentNewText language={language} /> */}
          <PaymentMain
            refno={refNumber}
            customerref={user?.unique_key}
            email={user?.email}
            full_name={user?.full_name}
            products={
              FunctionGroupingArrayByKey(cart, "type")
                ?.filter((row) => {
                  return row?.key === "PACKAGE";
                })[0]
                ?.value?.map((row) => {
                  return row?.master_type;
                })
                ?.join(",") || "My Laundry"
            }
            total={BasketCalculatePrice(
              form,
              cart,
              sameDayService,
              config?.same_day_price
            )}
          />
          <div ref={refButton} className="hello">
            <ButtonSubmitController
              classNameSubmit={`${
                clicked
                  ? " bg-laundry-bglight cursor-default"
                  : " bg-laundry-primary-blue md:hover:bg-laundry-gray-80  md:hover:order-blue cursor-pointer shadow-md  "
              } ${
                language === "TH"
                  ? " text-sm-th xl:text-base-th "
                  : " text-sm xl:text-base "
              }  w-full  md:p-3 xl:p-4 rounded-lg text-white font-semibold    leading-6 focus:outline-none h-h_50 md:h-input`}
              labelSubmit={
                <div>
                  {TEXT_PLACE_ORDER[language]} -{" "}
                  <span className="font-NotoSansThai">{SYMBOL_CURRENCY}</span>
                  {BasketCalculatePrice(
                    form,
                    cart,
                    sameDayService,
                    config?.same_day_price
                  )}
                </div>
              }
              data={form}
              trigger={(props) => {
                BasketPayment({
                  user,
                  form: props,
                  sameDayService,
                  dateTime,
                  address,
                  detailAddress,
                  refno: refNumber,
                  language,
                  navigate,
                  location,
                  FunctionResetState,
                  toast,
                  sameDayServicePrice: config?.same_day_price,
                  setClicked,
                  clicked,
                  tellUsMore,
                  tempDetailAddress,
                  addressDetail: detailAddress,
                });
              }}
            />
          </div>
        </div>
      </div>
      <TriggerObserver ref={CreateThisReference(setShow)} />
      {!show && !last && width && (
        // <div className="  bg-white fixed bottom-0 w-full h-[148px] md:h-[164px] z-20">
        <div className="  bg-white fixed bottom-0 w-full h-[106px] md:h-[124px] z-20">
          <PaymentMain
            refno={refNumber}
            customerref={user?.unique_key}
            email={user?.email}
            products={
              FunctionGroupingArrayByKey(cart, "type")
                ?.filter((row) => {
                  return row?.key === "PACKAGE";
                })[0]
                ?.value?.map((row) => {
                  return row?.master_type;
                })
                ?.join(",") || "My Laundry"
            }
            total={BasketCalculatePrice(
              form,
              cart,
              sameDayService,
              config?.same_day_price
            )}
          />
          <div
            className={`w-full px-4 md:px-10 xl:px-padding_read  py-4 md:py-8 ${STYLE_MAX_WIDTH_DESKTOP}`}
          >
            {/* <ComponentNewText language={language} /> */}

            <div
              style={{
                width: width,
              }}
              className=" mx-auto"
            >
              <ButtonSubmitController
                classNameSubmit={`${
                  clicked
                    ? " bg-laundry-bglight cursor-default "
                    : " bg-laundry-primary-blue md:hover:bg-laundry-gray-80  md:hover:order-blue cursor-pointer shadow-md "
                }  ${
                  language === "TH"
                    ? " text-sm-th xl:text-base-th "
                    : " text-sm xl:text-base "
                } w-full   md:p-3 xl:p-4 rounded-lg text-white font-semibold    leading-6 focus:outline-none h-h_50 md:h-input`}
                // labelSubmit={`Place Order - ${}`}
                labelSubmit={
                  <div>
                    {TEXT_PLACE_ORDER[language]} -{" "}
                    <span className="font-NotoSansThai">{SYMBOL_CURRENCY}</span>
                    {BasketCalculatePrice(
                      form,
                      cart,
                      sameDayService,
                      config?.same_day_price
                    )}
                  </div>
                }
                data={form}
                trigger={(props) => {
                  BasketPayment({
                    user,
                    form: props,
                    sameDayService,
                    dateTime,
                    address,
                    detailAddress,
                    refno: refNumber,
                    language,
                    navigate,
                    location,
                    FunctionResetState,
                    toast,
                    sameDayServicePrice: config?.same_day_price,
                    setClicked,
                    clicked,
                    tellUsMore,
                    tempDetailAddress,
                    addressDetail: detailAddress,
                  });
                }}
              />
            </div>
          </div>
        </div>
      )}

      <DrawerInfo
        open={open}
        setOpen={setOpen}
        image={FunctionGetPathUrl(config?.pickup_image_key_desktop)}
        imageMobile={FunctionGetPathUrl(config?.pickup_image_key_mobile)}
        title={config?.pickup_title}
        description={config?.pickup_description}
        description2={config?.pickup_description_2}
      />
      <DrawerInfo
        open={openSameday}
        setOpen={setOpenSameday}
        image={FunctionGetPathUrl(config?.same_day_image_key_desktop)}
        imageMobile={FunctionGetPathUrl(config?.same_day_image_key_mobile)}
        title={config?.same_day_title}
        description={config?.same_day_description}
        description2={config?.same_day_description_2}
      />
      <DrawerInfo
        open={openSummary}
        setOpen={setOpenSummary}
        image={FunctionGetPathUrl(config?.order_summary_image_key_desktop)}
        imageMobile={FunctionGetPathUrl(config?.order_summary_image_key_mobile)}
        title={config?.order_summary_title}
        description={config?.order_summary_description}
        description2={config?.order_summary_description_2}
      />
    </div>
  );
});

export default BusketDetails;
